export default __webpack_public_path__ + "static/media/blueHeaderLogo.7cb5b5b4.jpeg";